module.exports = {
      id: "image-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite.svg#image-icon",
      toString: function () {
        return this.url;
      }
    }